import { useState } from 'react';

import type { MinimalTarget } from '@/generated/model';

import type { RefuelsDateRange } from '../types/RefuelsDateRange.types';

export function useRefuelsSelection() {
  const [selectedTarget, setSelectedTarget] = useState<MinimalTarget>();
  const [selectedDates, setSelectedDates] = useState<RefuelsDateRange>();

  function selectTarget(target: MinimalTarget, dates?: RefuelsDateRange) {
    // Mobile omits dates to restart its step flow; desktop passes the current or default range to show results immediately.
    setSelectedTarget(target);
    setSelectedDates(dates);
  }

  function selectDates(dates: RefuelsDateRange) {
    setSelectedDates(dates);
  }

  function requestNewVehicle() {
    setSelectedTarget(undefined);
    setSelectedDates(undefined);
  }

  function requestNewDate() {
    setSelectedDates(undefined);
  }

  return {
    selectedTarget,
    selectedDates,
    selectTarget,
    selectDates,
    requestNewVehicle,
    requestNewDate,
  };
}
